<template>
  <div id="page-product-details">
    <distribution-list-form
        v-model="model"
        ref="form"
        :disallowed-report-types="usedReportTypes"
        :loading="loading"/>
        
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'company.distribution-list.view' })"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import DistributionListForm from '@/views/pages/companies/DistributionList/DistributionListForm';
import CanAccessMixin from "../../../../components/mixins/CanAccessMixin";

export default {
  name: "DistributionListEdit",
  components: {
    DistributionListForm,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.companies.distributionLists,
      componentAccess: {
        canDelete: {
          route: 'company.distribution-list.delete',
          access: false,
        },
      },
      entity: 'Distribution List',
      usedReportTypes: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.distributionListId;
    },
    companyName() {
      return this.model ? this.model.company.CompanyName : '';
    }
  },
  async mounted() {
    this.fetch(this.id);
    await this.getUsedReportTypes()
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      this.setReferences(['ReportType_FK']);

      delete params.Company_FK;

      return params;
    },
    async getUsedReportTypes() {
      try {
        const { data } = await this.$api.companies.relationship('distribution-lists',
            this.$route.params.id);
        this.usedReportTypes = data.data.map(({Type_PK}) => parseInt(Type_PK));
      } catch(e) {
        console.log(e);
      }
    },
    postSave() {
      this.back();
    },
    back() {
      this.$router.push({name: 'company', params:{activeTab: 4}})
    },
    deleteList() {
      const deleteRecord = async () => {
        try {
          await this.$api.companies.distributionLists.delete(this.id);
          await this.$router.back()
        } catch(e) {
          console.log(e);
        }
      }

      const message = "Warning: this operation is not reversible. Please confirm deletion of this role. "
          + "Are you sure you want to delete this list?";

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: message,
        accept: deleteRecord,
        acceptText: 'Delete'
      })
    }
  },
};
</script>

<style scoped>

</style>
